getSessionVariableKey = (placeId) ->
  return "mpp-request-a-deal-#{placeId}"

removeFromStorage = (placeId) ->
  sessionStorage?.removeItem getSessionVariableKey(placeId)

getFromStorage = (placeId) ->
  sessionStorage?.getItem getSessionVariableKey(placeId)

setToStorage = (placeId, value) ->
  if sessionStorage?
    sessionStorage.setItem getSessionVariableKey(placeId), value

class Groupon.RequestDeal

  constructor: (@el, @csrf, @placeId, @nearbyPlacesCount, @showModal) ->
    @$el = $ @el
    @rootUrl = '/merchant-page'
    @visibleCount = 3
    @$carousel = @$el.find '.request-deal-nearby-carousel'
    @$carouselPreviousButton = @$el.find '.jcarousel-control-prev'
    @$carouselNextButton = @$el.find '.jcarousel-control-next'
    @$carouselNotifyButton = @$el.find '.carousel-notify-button'
    @$requestADealButton = @$el.find '#request-deal-btn'
    @$loading = @$el.find '.loading'
    @$requestADealImageWrapper = @$el.find '.request-deal-image-wrapper'
    @$requestADealInfo = @$el.find '.request-deal-info'
    @$requestADealSubscribedWrapper = @$el.find '.subscribed-wrapper'
    @$requestADealNowFollowing = @$el.find '.now-following'
    @modalCreated = false

    @bindEventHandlers()

  bindEventHandlers: ->
    $(document).ready =>
      shouldOpenModal = @nearbyPlacesCount >= @visibleCount and @showModal
      @$requestADealButton.click =>
        @sendDealRequest(@placeId, shouldOpenModal)

      if getFromStorage(@placeId)?
        removeFromStorage @placeId
        @sendDealRequest(@placeId, shouldOpenModal, true)

  openModal: ->
    MPP.Modal.open '#request-deal-nearby-places-modal'

    if not @modalCreated
      @createNearbyCarousel()
      @modalCreated = true

  createNearbyCarousel: ->
    @$carousel.jcarousel({wrap: "circular"})
    carouselInstance = @$carousel.data('jcarousel')

    @$carouselPreviousButton.click => scrollCarouselBack(carouselInstance, @visibleCount)
    @$carouselNextButton.click => scrollCarouselForward(carouselInstance, @visibleCount)

    @$carousel.jcarousel().on 'jcarousel:visiblein', 'li', ->
      enqueueCarouselItem(this)

    @$carouselNotifyButton.click (event) =>
      event.preventDefault()
      $clickedButton = $(event.target)

      {placeId} = $clickedButton.data()
      closestLi = $clickedButton.closest("li")

      @sendDealRequest(placeId, false, false)
      markItemSelected(closestLi)
      decideCarouselScroll(carouselInstance, @visibleCount)

      $clickedButton.fadeOut(200)

    ## mark the first visibleCount items as visible
    _.each carouselInstance.list().children().slice(0, @visibleCount), (visibleElement) ->
      enqueueCarouselItem(visibleElement)

    # if we have less than 4 nearby places, we can hide the carousel controls
    if @nearbyPlacesCount <= 3
      @$carouselPreviousButton.hide()
      @$carouselNextButton.hide()

  showLoading: ->
    @$requestADealButton.hide()
    @$loading.show()

  hideLoading: ->
    @$loading.hide()
    @$requestADealButton.show()

  sendDealRequest: (placeId, openModal = false, triggeredOnPageLoad = false) ->
    obj =
      _csrf: @csrf
      placeId: placeId
      enabled: true
      triggeredOnPageLoad: triggeredOnPageLoad

    @showLoading()

    $.ajax
      url: "#{@rootUrl}/request-deal"
      type: 'POST'
      contentType: 'application/json'
      dataType: 'json'
      data: JSON.stringify obj
      success: (res) =>
        @hideLoading()

        return setToStorage(@placeId, true) if MPP.JsonResponseHandler.loginRequired res
        return unless res.result is 'ok'

        @$requestADealImageWrapper.remove()
        @$requestADealInfo.remove()
        @$requestADealSubscribedWrapper.removeAttr 'hidden'
        @$requestADealNowFollowing.removeAttr 'hidden'

        @openModal() if openModal

        ## let the follow module know that a deal has been requested
        @announceDealRequested(res, placeId)

  announceDealRequested: (res, requestedPlaceId) ->
    if @placeId == requestedPlaceId
      @$el.trigger 'deal-requested', [res.data.presentedFollowCount]

  enqueueCarouselItem = (item) ->
    $(item).attr("visible", "true")

  dequeueVisibleItems = (carouselInstance) ->
    _.each carouselInstance.children(), (carouselElement) ->
      $(carouselElement).attr("visible", "false")

  markItemSelected = (item) ->
    $(item).addClass 'requested'

  scrollCarouselBack = (carouselInstance, visibleCount) ->
    dequeueVisibleItems(carouselInstance.list())
    carouselInstance.scroll("-=#{visibleCount}")

  scrollCarouselForward = (carouselInstance, visibleCount) ->
    dequeueVisibleItems(carouselInstance.list())
    carouselInstance.scroll("+=#{visibleCount}")

  decideCarouselScroll = (carouselInstance, visibleCount) ->
    visibleAndUnchecked = carouselInstance.list().find("li[visible='true']:not(.requested)")

    if visibleAndUnchecked.length == 0
      setTimeout (-> scrollCarouselForward(carouselInstance, visibleCount) ), 400


$ ->
  el = '.request-deal'
  return unless $(el).length > 0

  place = $('.mpp-container').data()
  radConfig = $(el).data()
  csrfToken = $('meta[name=csrf-token]').attr('content')

  new Groupon.RequestDeal(el, csrfToken, place.placeId, radConfig.nearbyPlacesCount, radConfig.showModal);

  new Groupon.SharingButtons(
    el: $('.request-deal .share-links')
    merchantPage:
      permalink: window.location.pathname.replace('/biz/', '')
      merchantName: place.placeName
      twitterBody: radConfig.twitterBody
      emailSubject: radConfig.emailSubject
      emailBody: radConfig.emailBody
      campaign: 'UserReferral_mpp_rad'
  )
